<template>
  <div class="page-content-wrapper">
    <div class="section-wrapper">
      <div class="inner-container">
        <div class="section-head">
          <span>PORTFOLIO</span>
          <h2>My Works</h2>
        </div>
        <div class="section-portfolio-wrapper">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.bdlink">
                <div class="services-list-desc">
                  <h5 class="mb-0">BD LINK COMPUTER</h5>
                  <p class="mt-3">A Basic e-commerce website which help sharing the details of products of computer shop <strong>BDLINKCOMPUTER</strong></p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.rusbhara">
                <div class="services-list-desc">
                  <h5 class="mb-0">Rusbhara</h5>
                  <p class="mt-3">Rusbhara.com is an e-commerce website which sales fresh fruits online.</p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.evolve">
                <div class="services-list-desc">
                  <h5 class="mb-0">Evolve</h5>
                  <p class="mt-3">This Applications main focus is to serve the clients of Evolve Fitness system with keeping contact with coaches and maintaining workouts.</p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.aljilani">
                <div class="services-list-desc">
                  <h5 class="mb-0">ALJILANI</h5>
                  <p class="mt-3">A Saudi Arabian Retails And The Wholesales Of All Kind Of Packaging Requirements system for local and foreign markets</p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.a1daam">
                <div class="services-list-desc">
                  <h5 class="mb-0">A1DAAM</h5>
                  <p class="mt-3">A full functional multi store E-commerce system for a online business community to share and make a combined large market for customers to get any kind of product from different shop within one E-commerce platform</p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.a1daam_app">
                <div class="services-list-desc">
                  <h5 class="mb-0">A1DAAM MOBILE APP</h5>
                  <p class="mt-3">A full functional multi store E-commerce system for a online business community to share and make a combined large market for customers to get any kind of product from different shop within one E-commerce platform</p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.moddhobritto">
                <div class="services-list-desc">
                  <h5 class="mb-0">Moddhobritto</h5>
                  <p class="mt-3"></p>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
              <div class="each-project-wrapper">
                <img :src="media.readyjob">
                <div class="services-list-desc">
                  <h5 class="mb-0">READY JOB</h5>
                  <p class="mt-3"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-wrapper">
      <div class="inner-container">
        <div class="section-head">
          <span>KIND WORDS</span>
          <h2>Testimonial</h2>
        </div>
        <div class="section-testimonial-wrapper">
          <VueSlickCarousel :arrows="true" :dots="true" >
            <div class="each-testimonial">
              <div class="single-testimonials-in mx-auto text-center">
                <div class="single-testimonials-head p-5">
                  <p>"Great Work by Ahamed, understands the requirement very well and works really hard to deliver it."</p>
                </div>
                <div class="single-testimonials-foot mx-auto mt-4">
                  <img :src="media.ravi" alt="" class="mx-auto b-box">
                  <h4 class="mt-3 font-weight-bold">Ravi Kumar Singh</h4>
                  <span class="mt-1 d-block">CEO <a href="https://bitibe.com/">@ bitiberavi</a></span>
                </div>
              </div>
            </div>
            <div class="each-testimonial">
              <div class="single-testimonials-in mx-auto text-center">
                <div class="single-testimonials-head p-5">
                  <p>"Zobayer is fantastic, he understands the requirements thoroughly and delivers more than you ask for. Really enjoyed working with him on this project and would hire him again in the future as well."</p>
                </div>
                <div class="single-testimonials-foot mx-auto mt-4">
                  <img :src="media.vipul" alt="" class="mx-auto b-box">
                  <h4 class="mt-3 font-weight-bold">Vipul Singh</h4>
<!--                  <span class="mt-1 d-block">Web Developer</span>-->
                </div>
              </div>
            </div>
            <div class="each-testimonial">
              <div class="single-testimonials-in mx-auto text-center">
                <div class="single-testimonials-head p-5">
                  <p>"Absolutely amazing working with Zobayer. Understands the work and never leaves any gap in the requirement."</p>
                </div>
                <div class="single-testimonials-foot mx-auto mt-4">
                  <img :src="media.bdlink_ceo" alt="" class="mx-auto b-box">
                  <h4 class="mt-3 font-weight-bold">Razu Ahmed</h4>
                  <span class="mt-1 d-block">CEO @ <a href="http://bdlinkcomputer.com/">BD LINK Computer</a></span>
                </div>
              </div>
            </div>


            <template #prevArrow="arrowOption">
              <i class="las custom-arrow"></i>
            </template>
            <template #nextArrow="arrowOption">
              <i class="las custom-arrow"></i>
            </template>

          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

import Footer  from './../components/global/footer'
export default {
  data() {
    return {
      media: {
        bdlink: core.APP_PATH + '/projects/bdlink.jpg',
        evolve: core.APP_PATH + '/projects/evolve.jpg',
        aljilani: core.APP_PATH + '/projects/aljilani.jpg',
        rusbhara: core.APP_PATH + '/projects/rusbhara.jpg',
        a1daam: core.APP_PATH + '/projects/a1daam.jpg',
        a1daam_app: core.APP_PATH + '/projects/a1daam-app.jpg',
        readyjob: core.APP_PATH + '/projects/readyjob.jpg',
        moddhobritto: core.APP_PATH + '/projects/moddhobritto.jpg',
        bdlink_ceo: core.APP_PATH + '/avatar/bdlink_ceo.png',
        ravi: core.APP_PATH + '/avatar/ravi.png',
        vipul: core.APP_PATH + '/avatar/vipul.png',
      },
    }
  },
  watch: {

  },
  methods: {

  },
  created() {

  },
  mounted() {

  },
  components: {
    Footer, VueSlickCarousel
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/portfolio.vue